import { ImportStocksFieldNames, TImportStocksForm } from '../helpers/types';
import { IImportStocksDTO } from '@/models/productsImport.model';

class StocksImportDTO implements IImportStocksDTO {
  category_id: string;
  partner_id: string;
  file: File;

  constructor(values: TImportStocksForm) {
    this.category_id = values[ImportStocksFieldNames.CATEGORY_ID];
    this.partner_id = values[ImportStocksFieldNames.PARTNER_ID];
    this.file = values[ImportStocksFieldNames.FILE];
  }
}

export default StocksImportDTO;
